<template>
    <div>
        <html_header />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <!-- 待付款 -->
            <div class="dinbujindutiao" v-if="order_data.orderStatus == 'PENDING_PAYMENT'">
                <div style="float: left">
                    <div class="step">
                        1
                        <div class="step_top_txt">身份验证</div>
                        <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                    </div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    2
                    <div class="step_top_txt">付款到科隆化工</div>
                    <div class="step_bottom_txt"></div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    3
                    <div class="step_top_txt">卖家发货</div>
                    <div class="step_bottom_txt"></div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    4
                    <div class="step_top_txt">确认收货</div>
                    <div class="step_bottom_txt"></div>
                </div>
            </div>

            <!-- 待发货 -->
            <div class="dinbujindutiao" v-if="order_data.orderStatus == 'PENDING_SHIPMENT'">
                <div style="float: left">
                    <div class="step">
                        1
                        <div class="step_top_txt">身份验证</div>
                        <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                    </div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    2
                    <div class="step_top_txt">付款到科隆化工</div>
                    <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    3
                    <div class="step_top_txt">卖家发货</div>
                    <div class="step_bottom_txt"></div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    4
                    <div class="step_top_txt">确认收货</div>
                    <div class="step_bottom_txt"></div>
                </div>
            </div>

            <!-- 已发货 -->
            <div class="dinbujindutiao" v-if="order_data.orderStatus == 'SHIPPED'">
                <div style="float: left">
                    <div class="step">
                        1
                        <div class="step_top_txt">身份验证</div>
                        <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                    </div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    2
                    <div class="step_top_txt">付款到科隆化工</div>
                    <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    3
                    <div class="step_top_txt">卖家发货</div>
                    <div class="step_bottom_txt">{{ order_data.shippingAt }}</div>
                </div>
                <div class="step_line" style="background: #f2f2f2"></div>
                <div class="step" style="background: #e9e7e8; color: #333">
                    4
                    <div class="step_top_txt">确认收货</div>
                    <div class="step_bottom_txt"></div>
                </div>
            </div>

            <!-- 已收货 -->
            <div class="dinbujindutiao" v-if="order_data.orderStatus == 'RECEIVED'">
                <div style="float: left">
                    <div class="step">
                        1
                        <div class="step_top_txt">身份验证</div>
                        <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                    </div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    2
                    <div class="step_top_txt">付款到科隆化工</div>
                    <div class="step_bottom_txt">{{ order_data.payAt }}</div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    3
                    <div class="step_top_txt">卖家发货</div>
                    <div class="step_bottom_txt">2020-10-05 09:12:02</div>
                </div>
                <div class="step_line"></div>
                <div class="step">
                    4
                    <div class="step_top_txt">确认收货</div>
                    <div class="step_bottom_txt">2020-10-05 09:12:02</div>
                </div>
            </div>

            <div style="width: 100%; height: 311px; border: 1px solid #ede9e9; margin-top: 2%">
                <div class="left_box">
                    <div class="left_box_head">订单信息</div>
                    <div style="overflow: hidden; padding: 12px">
                        <div class="left_box_base_txt" style="width: 20%">收货地址：</div>
                        <div style="float: left; width: 80%">
                            {{ receiverBean.consignee }}
                            {{ receiverBean.phone }} <br />
                            {{ receiverBean.province }} / {{ receiverBean.city }} / {{ receiverBean.address }}
                        </div>
                    </div>
                    <div style="overflow: hidden; padding: 12px">
                        <div class="left_box_base_txt" style="width: 20%">卖家留言：</div>
                        <div style="float: left; width: 80%">{{ order_data.memo ? order_data.memo : '无留言' }}<br /></div>
                    </div>
                    <div style="overflow: hidden; padding: 12px">
                        <div class="left_box_base_txt" style="width: 20%">订单编号：</div>
                        <div style="float: left; width: 80%">{{ order_data.orderSn }} <span style="width: 60px; color: #fff; height: 19px; margin-right: 5px; display: inline-block; background-color: red; text-align: center" v-if="order_data.returnBack === true">退换订单</span></div>
                    </div>
                    <div style="overflow: hidden; padding: 12px">
                        <div class="left_box_base_txt" style="width: 20%">商家：</div>
                        <div style="float: left; width: 80%">{{ order_data.storeName }}</div>
                    </div>
                    <div @click="zukf(order_data)" class="zukf">
                        咨询客服
                    </div>
                </div>
                <div class="right_box" style="float: left; width: 60%">
                    <!-- 待付款  -->
                    <div v-if="order_data.orderStatus == 'PENDING_PAYMENT'" style="margin-left: 86px">
                        <div style="overflow: hidden; margin-top: 40px">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1">订单状态：待支付订单</div>
                        </div>
                        <div style="margin-left: 46px">
                            <div class="querenshouhuo_txt" style="margin-top: 10px">
                                您还有<span style="color: #f24145">{{ daifukuan_daojishi }}</span
                                >；来付款，超时订单自动关闭
                            </div>
                            <div style="margin-top: 10px">
                                您可以
                                <span class="querenshouhuo_but1" @click="qufukuan">付款</span>
                                <span @click="_quxiaodindan" class="quxiaodindan">取消订单</span>
                            </div>
                        </div>
                    </div>
                    <!-- 待审核 -->
                    <div v-if="order_data.orderStatus == 'PENDING_AUDIT'" style="margin-left: 86px">
                        <div style="overflow: hidden; margin-top: 40px">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1" style="margin-top: 6px">订单状态：等待商家审核</div>
                        </div>
                        <!-- <div style="margin-left: 46px">
                            <div class="querenshouhuo_txt" style="margin-top: 10px">
                                您还有<span style="color: #f24145">{{ daifukuan_daojishi }}</span
                                >；来付款，超时订单自动关闭
                            </div>
                            <div style="margin-top: 10px">
                                您可以
                                <span class="querenshouhuo_but1" @click="qufukuan">付款</span>
                                <span @click="_quxiaodindan" class="quxiaodindan">取消订单</span>
                            </div>
                        </div> -->
                    </div>

                    <!-- 已付款 -->
                    <div v-if="order_data.orderStatus == 'PENDING_SHIPMENT'" style="overflow: hidden; width: 100%; margin-top: 8%; padding-left: 40px">
                        <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                        <div class="tips_txt1">订单状态：买家待发货!</div>
                    </div>

                    <!-- 待收货 -->
                    <div v-if="order_data.orderStatus == 'SHIPPED'" style="margin-left: 86px">
                        <div style="overflow: hidden; margin-top: 40px">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1">订单状态：卖家已发货，等待买家收货</div>
                        </div>

                        <div style="margin-left: 46px">
                            <div class="querenshouhuo_txt" style="margin-top: 10px">
                                您还有<span style="color: #f24145">{{ querenshouhuo_daojishi }}</span
                                >；来确认收货，超时订单自动确认收货
                            </div>
                            <div style="margin-top: 10px">
                                <span style="margin-right: 2em"
                                    >物流：<a class="kuaidi" :href="`https://www.kuaidi100.com/chaxun?com=${order_data.shippingMethodName}&nu=${order_data.shippingNo}`">{{ order_data.shippingMethodName }}</a></span
                                >
                                <span
                                    >运单号：<a class="kuaidi" :href="`https://www.kuaidi100.com/all/yd.shtml?com=${order_data.shippingMethodName}&nu=${order_data.shippingNo}`">{{ order_data.shippingNo }}</a></span
                                >
                            </div>
                            <div style="margin-top: 10px">发货时间：{{ order_data.shippingAt }}</div>
                            <div style="margin-top: 10px">
                                您可以
                                <span class="querenshouhuo_but1" @click="querenshouhuo" style="cursor: pointer">确认收货</span>
                            </div>
                        </div>

                        <div style="margin-top: 10px; position: relative" v-if="gengduodizhi">
                            <div style="width: 100%; background: #f4f4f4; position: absolute; z-index: 999; padding: 10px">
                                <div class="dizhi_more_item">2020-10-05 08:44:02 【成都市】快件已从成都市发出，正发往上海转运中心</div>
                                <div class="dizhi_more_item">2020-10-05 08:44:02 【成都市】快件已从成都市发出，正发往上海转运中心</div>
                                <div class="dizhi_more_item">2020-10-05 08:44:02 【成都市】快件已从成都市发出，正发往上海转运中心</div>
                                <div class="dizhi_more_item">2020-10-05 08:44:02 【成都市】快件已从成都市发出，正发往上海转运中心</div>
                                <div class="dizhi_more_item" style="font-size: 12px; color: #9999">以下信息由物流公司提供，如无跟踪信息或有疑问，请查顺丰快递官方网站或联系其公示电话</div>
                            </div>
                        </div>
                    </div>

                    <!-- 已收货 -->
                    <div v-if="order_data.orderStatus == 'RECEIVED'" style="overflow: hidden; width: 100%; margin-top: 8%; padding-left: 40px">
                        <div style="overflow: hidden">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1">订单状态：交易成功</div>
                        </div>
                        <div style="margin-top: 20px">
                            <div class="wuliu_title" style="margin-left: 46px">物流</div>
                            <div style="float: left; width: 80%">
                                <div style="overflow: hidden">
                                    <div style="float: left; margin-left: 20px">顺丰快递</div>
                                    <div style="float: left; margin-left: 20px">运单号：SF202010151111</div>
                                </div>
                                <div style="overflow: hidden">
                                    <div style="float: left; margin-left: 20px; margin-top: 20px">【成都市】快件已从成都市发出，正发往上海转运中心快件已从成都市发出，正发往上海转运中心 快件已从成都市发出，正发往上海转运中心 快件已从成都市发出，正发往上海转运中心</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 已关闭 -->
                    <div v-if="order_data.orderStatus == 'CANCELED'" style="overflow: hidden; width: 100%; margin-top: 8%; padding-left: 40px">
                        <div style="overflow: hidden">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1">订单状态：该订单已关闭</div>
                        </div>
                        <div style="overflow: hidden; margin-top: 20px">
                            <div class="wuliu_title" style="margin-left: 46px">物流：</div>
                            <div class="wuliu_title">该订单已取消</div>
                        </div>
                    </div>

                    <div v-if="order_data.orderStatus == 'COMPLETED'" style="overflow: hidden; width: 100%; margin-top: 8%; padding-left: 40px">
                        <div style="overflow: hidden">
                            <img src="../assets/tishi.png" style="width: 36px; float: left; height: 36px" alt="" />
                            <div class="tips_txt1">订单状态：交易成功</div>
                        </div>
                        <div style="overflow: hidden; margin-top: 20px; margin-left: 46px">
                            <div style="margin-top: 10px">
                                <span style="margin-right: 2em">物流：{{ order_data.shippingMethodName }}</span>
                                <span>运单号：{{ order_data.shippingNo }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="padding:20px;border: 1px solid #EDE9E9;margin-top:20px">
                <withGoods :storeId="order_data.storeId" :uuid="order_data.uuid" v-if="order_data.storeId" :orcContent="order_data.orcContent" :disable="true" />
            </div>

            <div style="width: 100%; height: 40px; border: 1px solid #ede9e9; margin-top: 2%">
                <div class="goods_table_head_txt">商品</div>
                <div class="goods_table_head_txt">
                    <a-row>
                        <a-col :span="8"> 折扣价 </a-col>
                        <a-col :span="8"> 数量 </a-col>
                        <a-col :span="8"> 运费(不含首重) </a-col>
                        <!-- <a-col :span="6">
                  优惠
                </a-col> -->
                    </a-row>
                </div>
                <div class="goods_table_head_txt">状态</div>
            </div>
            <div style="width: 100%; height: 120px; border: 1px solid #ede9e9; border-top: none" :key="index" v-for="(item, index) in order_data.ordersItemList">
                <a-row>
                    <a-col :span="8">
                        <div style="width: 100%; height: 100%">
                            <img :src="'/api/file/preview/' + item.cover" style="width: 80px; height: 80px; float: left; margin-left: 4%; margin-top: 4%" alt="" v-if="item.cover" @click="tiao(item)" class="tiao" />
                            <div v-else style="width: 80px; height: 80px; float: left; margin-left: 4%; margin-top: 4%; background: #fff; border: 1px solid #eeeeee"></div>
                            <div class="goods_table_base_txt">
                                <div style="margin-top: 4%; overflow: hidden; margin-left: 4%">
                                    <div style="float: left" @click="tiao(item)" class="tiao">{{ item.productName }}</div>
                                    <div style="margin-left: 2%; float: left">品牌：{{ item.brandName }}</div>
                                </div>
                                <div style="margin-top: 4%; overflow: hidden; margin-left: 4%; color: #666; font-size: 12px">
                                    <div style="float: left">货号: {{ item.skuSn }}</div>
                                    <div style="margin-left: 2%; float: left">CAS号：{{ item.casNum }}</div>
                                </div>
                                <div style="margin-top: 4%; overflow: hidden; margin-left: 4%; color: #666; font-size: 12px">
                                    <div style="float: left">包装: {{ item.packaging }}</div>
                                    <div style="margin-left: 2%; float: left">规格：{{ item.specification }}</div>
                                </div>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="8">
                        <a-row>
                            <a-col :span="8" style="line-height: 120px; text-align: center"> ￥{{ item.price / 100 }} </a-col>
                            <a-col :span="8" style="line-height: 120px; text-align: center"> x{{order_data.returnBack?item.afterSale.returnNum: item.quantity }} </a-col>
                            <a-col :span="8" style="line-height: 120px; text-align: center">
                                {{ item.freight | moneyStr }}
                            </a-col>
                            <!-- <a-col :span="6" style="line-height: 120px;text-align:center">
                    {{item.promotionDiscount|moneyStr}}
                  </a-col> -->
                        </a-row>
                    </a-col>
                    <a-col :span="8" class="goods_table_head_txt" style="line-height: 120px; color: #666; border-left: 1px solid #ede9e9">
                        <span v-if="order_data.orderStatus == 'PENDING_PAYMENT'">待付款</span>
                        <span v-if="order_data.orderStatus == 'PENDING_SHIPMENT'">待发货</span>
                        <span v-if="order_data.orderStatus == 'SHIPPED'">已发货</span>
                        <span v-if="order_data.orderStatus == 'RECEIVED'">已收货</span>
                        <span v-if="order_data.orderStatus == 'OFFLINE_PAID'">离线付款</span>
                        <span v-if="order_data.orderStatus == 'COMPLETED'">已完成</span>
                        <span v-if="order_data.orderStatus == 'CANCELED'">已取消</span>
                        <span v-if="order_data.orderStatus == 'PENDING_REFUND'">待退款</span>
                        <span v-if="order_data.orderStatus == 'REFUND'">退款</span>
                    </a-col>
                </a-row>
            </div>

            <div style="width: 100%; background: #f4f4f4; margin: 20px 0; padding: 20px 0; overflow: hidden">
                <div class="bottom_box_right" style="float: right; padding-right: 4%; width: 20%; line-height: 24px">
                    <div style="overflow: hidden">
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right">商品总价：</div>
                        <div class="bottom_box_right_base">{{ order_data.productAmount | moneyStr }}</div>
                    </div>
                    <div style="overflow: hidden">
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right">运费(含首重)：</div>
                        <div class="bottom_box_right_base"><span v-if="order_data.freight !== 0">+</span>{{ order_data.freight | moneyStr }}</div>
                    </div>
                    <div style="overflow: hidden">
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right">优惠：</div>
                        <div class="bottom_box_right_base"><span v-if="order_data.promotionDiscount !== 0">-</span>{{ order_data.promotionDiscount | moneyStr }}</div>
                    </div>
                    <div style="overflow: hidden">
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right">积分抵扣：</div>
                        <div class="bottom_box_right_base"><span v-if="order_data.pointOffsetAmount !== 0">-</span>{{ order_data.pointOffsetAmount | moneyStr }}</div>
                    </div>
                    <div style="overflow: hidden" v-if="order_data.returnBack">
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right; font-weight: bold">退款金额：</div>
                        <div class="bottom_box_right_base" style="color: #f24145; font-weight: Semibold">{{ order_data.orderAmount | moneyStr }}</div>
                    </div>
                    <div style="overflow: hidden" v-else>
                        <div class="bottom_box_right_base" style="margin-right: 2%; width: 50%; text-align: right; font-weight: bold">实付款：</div>
                        <div class="bottom_box_right_base" style="color: #f24145; font-weight: Semibold">{{ order_data.amountPaid | moneyStr }}</div>
                    </div>
                </div>
                <div class="bottom_box_left">返{{ order_data.canGetPoint }}积分</div>
            </div>
            <div v-if="order_data.precursorChemicals == true" class="shangchuan">
                <p>注: 易制毒化学品运输备案回执请在此上传</p>
                <div v-if="order_data.receiptList == ''">
                    <a-upload name="file" :multiple="true" action="/api/file/upload" @change="handleChange" style="width: 60px; margin-left: 40px">
                        <a-button> <a-icon type="upload" /> 上传回执 </a-button>
                    </a-upload>
                </div>
                <div v-else>
                    <div style="width: 50%; font-size: 14px; display: flex; justify-content: space-between; height: 60px; line-height: 60px; color: #000; font-family: Microsoft YaHei; background-color: rgb(244, 244, 244); padding: 0 40px">
                        <p style="">运输回执</p>
                        <p style="">上传人</p>
                        <p style="">上传时间</p>
                    </div>
                    <div style="border: 1px solid rgb(244, 244, 244); width: 50%; font-size: 14px; display: flex; justify-content: space-between; height: 60px; line-height: 60px; color: #000; font-family: Microsoft YaHei; padding: 0 40px">
                        <!-- <p style="width:130px;overflow: hidden;">{{order_data.receiptList[0].fileName}}</p> -->
                        <a style="width: 130px; overflow: hidden" :href="`/api/file/download/${order_data.receiptList[0].fileId}`">{{ order_data.receiptList[0].fileName }}</a>
                        <p>{{ order_data.receiptList[0].upBy }}</p>
                        <p>{{ order_data.receiptList[0].upAt }}</p>
                    </div>
                </div>
            </div>
            <div style="width: 100%; height: 50px"></div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import html_header from '../public/head';
import foot from '../public/foot';
import withGoods from './withGoods.vue';

export default {
    name: 'PayTo',
    components: {
        html_header,
        foot,
        withGoods
    },
    data() {
        return {
            shangchuananiu: true,
            daifukuan_daojishi: '', //待付款倒计时
            order_data: '', //所有信息
            gengduodizhi: false, //是否显示更多物流信息
            querenshouhuo_daojishi: '', //确认收货倒计时
            receiverBean: {}
        };
    },
    filters: {
        moneyStr(value) {
            value = value ? value / 100 : 0;
            return '￥' + value.toFixed(2);
        }
    },
    methods: {
        zukf(e) {
            let userId = JSON.parse(localStorage.getItem('user_info'));
            let orderId = e.uuid;
            let storeId = e.storeId;
            this.api.isOpen(storeId).then(res => {
                if (res.ok == true) {
                    window.open(`/cus/#/client?storeId=${storeId}&entranceId=184d9ab5-cfd8-473d-bd19-064a868287b7&userId=${userId.uuid}&orderId=${orderId}`);
                    let list = {
                        storeId: orderId,
                        userId: orderId
                    };
                    this.api.tiaozhuan(list).then(res => {});
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                const id = {
                    uuid: this.order_data.uuid,
                    fileId: info.file.response.data.uuid
                };
                this.api.orderhuizhi(id).then(res => {
                    if (res.ok === true) {
                        this.$message.success(`${info.file.name} ${res.message}`);
                        this.shangchuananiu = false;
                        this.get_order_jindu();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else if (info.file.status === 'error') {
                this.$message.error(`${info.file.name} file upload failed.`);
            }
        },
        tiao(e) {
            this.$router.push('/goods_details?uuid=' + e.productId);
        },
        // 时间倒计时
        djs(value, code) {
            //获取当前时间
            var that = this;
            var date = new Date();
            var now = date.getTime();
            //设置截止时间
            //在pc端浏览器可以这样写
            var endDate = new Date(value); //移动端必须这样写，因为ios不支持日期中间是-链接，会报错
            //var endDate = new Date("2019/7/22 00:00:00");
            var end = endDate.getTime(); //时间差
            var differTime = end - now; //定义变量,h,m,s保存倒计时的时间
            var h, m, s;
            if (differTime >= 0) {
                h = Math.floor(differTime / 1000 / 60 / 60);
                m = Math.floor((differTime / 1000 / 60) % 60);
                s = Math.floor((differTime / 1000) % 60);
                h = h < 10 ? '0' + h : h;
                m = m < 10 ? '0' + m : m;
                s = s < 10 ? '0' + s : s;
                var timeDom = h + '小时' + m + '分' + s + '秒';
                // that.setData({
                //     hour: h,
                //     min: m,
                //     sec: s
                // })
                setTimeout(function() {
                    that.djs(value);
                }, 1000);
            } else {
                var timeDom = '00小时 00分 00秒';
            }

            if (this.order_data.orderStatus == 'SHIPPED') {
                // 自动收货倒计时
                this.querenshouhuo_daojishi = timeDom;
            } else {
                // 待付款倒计时
                this.daifukuan_daojishi = timeDom;
            }
        },
        // 取消订单
        _quxiaodindan() {
            const that = this;
            that.$confirm({
                title: `是否取消这个订单?`,
                onOk() {
                    that.api.order_cancel(that.order_data.uuid).then(res => {
                        if (res.ok) {
                            that.get_order_jindu();
                            that.$message.success(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 确认收货
        querenshouhuo() {
            const that = this;
            that.$confirm({
                title: `是否确认收货?`,
                onOk() {
                    that.api
                        .order_received({
                            id: that.order_data.uuid
                        })
                        .then(res => {
                            if (res.ok) {
                                that.get_order_jindu();
                                that.$message.success(res.message);
                                this.$router.push('/order');
                            } else {
                                that.$message.error(res.message);
                            }
                        });
                }
            });
        },
        // 去付款页
        qufukuan(e) {
            this.$router.push('/credit_pay?uuid=' + this.order_data.uuid);
        },
        // 获取订单进度
        get_order_jindu() {
            this.api.get_order_jindu(this.$route.query.uuid).then(res => {
                if (!res.ok) {
                    this.$message.error(res.message);
                    return false;
                }
                this.order_data = res.data;
                console.log(res.data, '112212');
                this.receiverBean = res.data.receiverBean;
                this.djs(res.data.autoCloseTime, 0);
                this.djs(res.data.autoReceivedTime, 1);
            });
        }
    },
    created() {
        this.get_order_jindu();
    }
};
</script>

<style scoped>
.zukf {
    width: 120px;
    height: 33px;
    border: 1px solid #2b9a34;
    color: #2b9a34;
    line-height: 35px;
    text-align: center;
    margin-left: 10px;
    /* border-radius: 10px; */
    cursor: pointer;
}
.zukf:hover {
    background: #2b9a34;
    color: #fff;
}
.shangchuan {
    height: 50px;
    line-height: 50px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #999;
}
.wuliu_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    float: left;
}

.quxiaodindan {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    /* color: #333333; */
    line-height: 16px;
    margin-left: 20px;
    cursor: pointer;
    color: #2b9a34;
}

.kuaidi {
    color: #000;
}
.kuaidi:hover {
    color: #2b9a34;
}

.tiao:hover {
    cursor: pointer;
}
.dinbujindutiao {
    overflow: hidden;
    padding: 4% 0;
    margin: auto;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.dizhi_more_item {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-top: 10px;
}

.querenshouhuo_but1 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 32px;
    padding: 5px 10px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    margin-left: 10px;
    cursor: pointer;
}

.querenshouhuo_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 20px;
}

.bottom_box_right_base {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    float: left;
}

.bottom_box_left {
    font-size: 14px;
    color: #666666;
    margin-left: 20px;
}

.goods_table_base_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
}

.goods_table_head_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    width: 33.33%;
    height: 100%;
    float: left;
    line-height: 40px;
}

.tips_txt1 {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
    float: left;
    margin-left: 10px;
}

.left_box_base_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    line-height: 16px;
    float: left;
}

.left_box_head {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 2%;
    background: #f4f4f4;
    border: 1px solid #ede9e9;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
}

.left_box {
    width: 40%;
    height: 100%;
    border-right: 1px solid #ede9e9;
    float: left;
}

.step_bottom_txt {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    text-align: center;
    width: 200px;
    position: absolute;
    bottom: -30px;
    left: -80px;
}

.step_top_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: center;
    position: absolute;
    top: -30px;
    width: 100px;
    left: -30px;
}

.step {
    width: 30px;
    height: 30px;
    background: #2b9a34;
    border-radius: 50%;
    float: left;
    text-align: center;
    line-height: 30px;
    color: #fff;
    font-size: 14px;
    position: relative;
}

.step_line {
    width: 25%;
    height: 6px;
    background: #2b9a34;
    opacity: 0.8;
    float: left;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/pay_to.vue